import React from "react";
import "./Privacy_Policy.css";

const Privacy_Policy = () => {
  return (
    <>
      <section className=" Privacy_Policy">
        <div className="privacy_banner">
          <p className="banner_text">Privacy Policy</p>
        </div>
        <div className="container">
          <div className="card card_div">
            <h2>1. Information We Collect</h2>
            <p>We collect information from and about you in the following ways:</p>

            <h3>A. Information you provide</h3>
            <ul>
              <li>Account information (e.g., name, email address, password).</li>
              <li>Profile information you choose to provide (e.g., nationality, education background, internship/study interests, language level).</li>
              <li>Application or inquiry information (e.g., messages, form submissions, documents you upload such as CVs).</li>
              <li>Communications (e.g., emails, chat messages, support requests).</li>
              <li>User-generated content you post or submit (e.g., comments, feedback, testimonials), if enabled.</li>
            </ul>

            <h3>B. Information collected automatically</h3>
            <ul>
              <li>Device and usage information (e.g., IP address, browser type, device identifiers, pages viewed, dates/times, referring URLs).</li>
              <li>Cookie and similar technologies data (see Section 4).</li>
            </ul>

            <h3>C. Information from third parties</h3>
            <p>
              We may receive information from service providers or partners (e.g., analytics, email delivery) and from social media platforms if you interact with our official pages.
            </p>

            <h2>2. How We Use Information</h2>
            <p>We use information to:</p>
            <ul>
              <li>Provide, operate, and improve the Services.</li>
              <li>Create and manage accounts and authenticate users.</li>
              <li>Respond to inquiries, provide customer support, and send administrative messages.</li>
              <li>Personalize content and user experience.</li>
              <li>Monitor, prevent, and address fraud, security incidents, and technical issues.</li>
              <li>Comply with legal obligations and enforce our Terms of Use.</li>
              <li>Send marketing communications where permitted by law; you can opt out (see Section 7).</li>
            </ul>

            <h2>3. How We Share Information</h2>
            <p>We do not sell your personal information. We may share information in these circumstances:</p>

            <h3>A. Service providers</h3>
            <p>
              We share information with vendors that help us run the Services (e.g., hosting, analytics, email delivery, customer support, security). They may access information only to perform services for us and must protect it.
            </p>

            <h3>B. Legal and safety</h3>
            <p>
              We may disclose information if we believe in good faith it is necessary to:
            </p>
            <ol>
              <li>Comply with law or valid legal process.</li>
              <li>Protect the rights, safety, and security of users, AFI, or the public.</li>
              <li>Investigate and prevent fraud, abuse, or security incidents.</li>
              <li>Enforce our agreements.</li>
            </ol>

            <h3>C. Business transfers</h3>
            <p>
              If we are involved in a merger, acquisition, financing, reorganization, bankruptcy, or sale of assets, information may be transferred as part of that transaction.
            </p>

            <h3>D. With your direction</h3>
            <p>
              We may share information when you request or authorize us to do so.
            </p>

            <h2>4. Cookies and Similar Technologies</h2>
            <p>
              We use cookies and similar technologies (such as pixels and local storage) to operate the Services, understand usage, and improve performance.
            </p>

            <p>Types of cookies we may use:</p>
            <ul>
              <li>Essential cookies: required for core functionality (e.g., login).</li>
              <li>Analytics cookies: help us understand site traffic and usage.</li>
              <li>Preference cookies: remember settings and choices.</li>
            </ul>

            <p>
              Your choices: You can control cookies through your browser settings. If you disable certain cookies, parts of the Services may not function properly.
            </p>

            <h2>5. Data Retention</h2>
            <p>
              We retain personal information for as long as necessary to provide the Services and for legitimate business and legal purposes, including maintaining records, resolving disputes, and enforcing agreements. Retention periods vary depending on the type of information and why we collected it.
            </p>

            <h2>6. Security</h2>
            <p>
              We use reasonable administrative, technical, and organizational safeguards designed to protect information. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.
            </p>

            <h2>7. Your Choices and Rights</h2>

            <h3>A. Marketing communications</h3>
            <p>
              You can opt out of marketing emails by using the unsubscribe link in those emails. You may still receive non-marketing communications (e.g., account or policy updates).
            </p>

            <h3>B. Account information</h3>
            <p>
              You may review or update certain account information by logging into your account, if available.
            </p>

            <h3>C. US state privacy rights</h3>
            <p>
              Depending on where you live, you may have rights to request access to, correction of, deletion of, or a copy of certain personal information, and to opt out of certain processing (such as targeted advertising).
            </p>
            <p>
              To submit a request, contact us at <strong>privacy@afiway.com</strong>.
            </p>
            <p>
              We may verify your request before responding. You may also be able to appeal a denied request, where required by law.
            </p>

            <h3>D. EEA/UK (GDPR) notice (if applicable)</h3>
            <p>
              If you are in the European Economic Area or the UK, you may have additional rights under applicable data protection laws, including access, correction, deletion, restriction, portability, and objection. You may also withdraw consent where processing is based on consent.
            </p>
            <p>
              If you believe we have not addressed your concerns, you may have the right to lodge a complaint with your local data protection authority.
            </p>

            <h2>8. Children’s Privacy</h2>
            <p>
              The Services are not intended for children under 13, and we do not knowingly collect personal information from children under 13. If you believe a child has provided us personal information, contact us at <strong>privacy@afiway.com</strong> and we will take appropriate steps to delete it.
            </p>

            <h2>9. International Transfers</h2>
            <p>
              Your information may be processed in countries other than where you live, including the United States. We take steps designed to ensure an appropriate level of protection for transfers where required by law.
            </p>

            <h2>10. Links to Other Websites</h2>
            <p>
              The Services may contain links to third-party sites. We are not responsible for their privacy practices. We encourage you to review the privacy policies of those third parties.
            </p>

            <h2>11. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. If we make material changes, we will provide notice by posting the updated policy on the Site and/or by other appropriate means. The effective date above indicates when this policy was last updated.
            </p>

            <h2>12. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or our privacy practices, contact us at:
            </p>
            <p>
              Email: <strong>privacy@afiway.com</strong><br></br>
              Mail: Ambassadeur Francophone Inc., 710 Seneca St 107 Seattle, WA 98101, USA
            </p>

          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy_Policy;
